import { Suspense, useEffect } from "react";
import { useUserProducts } from "../../hooks/ProductHooks";
import { AnimatePresence } from "motion/react";
import { filterProductsByAttr } from "../../utils/ProductsUtils";
import Page from "../../layout/Page";
import ContentSection from "../../components/ContentSection";
import ProductGrid from "../../components/ProductGrid";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { ProductPreviewLoadingPlaceholder } from "../../components/ProductPreview";
import { usePage } from "../../hooks/CmsHooks";
import { shopUrl } from "../../config/urls";
import CockpitLayoutComponents from "../../components/CockpitLayoutComponents";
import "./style.scss";
import { useNavigationContext } from "../../functional-components/NavigationContext";

const ShopFrontPageProductGrid = () => {
  const products = useUserProducts();
  const campaignProducts = filterProductsByAttr(products, "campaign_product");
  const t = useBjelinTranslations();

  return (
    <>
      {campaignProducts.length > 0 && (
        <>
          <h1>{t("campaigns.heading")}</h1>
          <ProductGrid cols={4} products={campaignProducts} layout={"card"} />
        </>
      )}
    </>
  );
};

const ShopFrontPage = () => {
  const { registerCurrentPaths } = useNavigationContext();
  const page = usePage(shopUrl);
  const t = useBjelinTranslations();
  const hasHeroBox = page?.content?.[0].component === "herobox";

  useEffect(() => {
    registerCurrentPaths({
      all: shopUrl
    });
  }, [registerCurrentPaths]);

  return (
    <Page name="shop-front-page" key="shop-front-page" title={t("shop")}>
      {!hasHeroBox && <div className="content-padding-for-menu-bar" />}
      <CockpitLayoutComponents components={page.content} />
      <ContentSection>
        <AnimatePresence mode={"wait"}>
          <Suspense fallback={<ProductPreviewLoadingPlaceholder cols={3} />}>
            <ShopFrontPageProductGrid />
          </Suspense>
        </AnimatePresence>
      </ContentSection>
    </Page>
  );
};

export default ShopFrontPage;
